/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileAiff = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M12.94 17h-1.2l-.332-1.028h-1.85L9.228 17H8.077l1.904-5.017h1.042zm-3.092-1.938h1.266l-.636-1.972zM14.554 17h-1.077v-5.017h1.077zm4.18-4.105h-2.126v1.262h1.884v.911h-1.884V17h-1.076v-5.017h3.202zm3.949 0h-2.125v1.262h1.883v.911h-1.883V17H19.48v-5.017h3.202z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileAiff as FileAiff };
